<template>
    <div>
        <div id="page">
            <div class="page-content pb-0">
                <div class="page-title page-title-small">
                    <h1 class="text-white">
                        نصب اپلیکیشن تَسکینو
                        <button data-menu="intro" class="position-static mr-1"><i class="fa fa-question-circle helpIco text-white"></i></button>
                    </h1>
                </div>
                <div class="card header-card shape-rounded" data-card-height="100">
                    <div class="card-overlay bg-highlight opacity-95"></div>
                    <div class="card-overlay dark-mode-tint"></div>
                </div>
                <div class="card card-style mb-3">
                    <div class="content pb-2">
                        <p class="mb-0 text-justify">
                            تَسکینو،
                            <strong>اپلیکیشن برنامه ریزی و مدیریت وظایف</strong>،
                            در سه نسخه اندروید، ios و نسخه وب مخصوص دسکتاپ ارائه شده است. تسکنیو امکان برنامه ریزی، مدیریت وظایف و فعالیت ها، ثبت وظیفه و ارجاع به اعضای تیم، نظارت بر روند پیشرفت وظایف و ... را به راحتی و به صورت آنلاین فراهم می نماید.
                        </p>

                    </div>
                </div>

                <div class="card card-style text-center mb-3">
                    <div class="content pb-2">
                        <div>
                            <i class="fab fa-android color-green1-dark fa-5x pt-3 icon-size"></i>
                        </div>
                        <h2 class="font-700 my-4 ">نصب اپلیکیشن در اندروید</h2>
                        <p class="text-justify mb-2">
                            برای دریافت مستقیم فایل نصب نسخه اندروید اپلیکیشن روی دکمه اندروید و پس از اتمام دانلود روی دکمه install کلیک کنید.
                        </p>
                        <div class="row mb-0">
                            <div class="col-12">

                                <a id="linkApp" href="https://cdn.dssnovinit.com/application/TaskManager/Taskino-2-5-28.apk" class="add-button btn btn-m btn-full rounded-s shadow-xl text-uppercase font-900 bg-highlight mb-3">دریافت مستقیم فایل نصب نسخه اندروید</a>

                                <a href="https://cafebazaar.ir/app/com.sardchal.task" class="add-button btn btn-m btn-full rounded-s shadow-xl text-uppercase font-900 bg-green1-dark">دریافت نسخه اندروید از کافه بازار</a>

                            </div>
                        </div>
                    </div>
                </div>
                <div class="card card-style text-center mb-3">
                    <div class="content pb-2">
                        <div>
                            <i class="fab fa-apple color-red1-light fa-5x pt-3 icon-size"></i>
                        </div>
                        <h2 class="font-700 my-4">نصب اپلیکیشن در ios</h2>
                        <p class="text-justify mb-2">
                            با استفاده از مرورگر safari و امکان add to home screen اپلیکیشن تسکینو را در سیستم عامل های ios راه اندازی نمایید.
                        </p>
                        <div class="row mb-0">
                            <div class="col-12">
                                <button class="simulate-ios-banner btn btn-m btn-full rounded-s shadow-xl text-uppercase font-900 bg-highlight w-100">ios</button>
                            </div>

                        </div>
                    </div>
                </div>

                <div class="card card-style text-center">
                    <div class="content pb-2">
                        <div>
                            <i class="fa fa-desktop color-magenta2-light fa-5x pt-3 icon-size"></i>
                        </div>
                        <h2 class="font-700 my-4">نسخه وب مخصوص دسکتاپ</h2>
                        <p class="text-justify mb-2">
                            اپلیکیشن تسکنیو به صورت نسخه وب مخصوص دسکتاپ از طریق مراجعه به آدرس
                            <span>https://task.dssnovinit.com</span>
                            در دسترس می باشد.
                        </p>
                        <div class="row mb-0">
                            <div class="col-12">
                                <a href="https://task.dssnovinit.com" class="btn btn-m btn-full rounded-s shadow-xl text-uppercase font-900 bg-highlight">نسخه وب</a>
                            </div>

                        </div>
                    </div>
                </div>
            </div>



            <div id="menu-install-pwa-ios"
                 class="menu menu-box-bottom menu-box-detached rounded-m"
                 data-menu-height="360"
                 data-menu-effect="menu-parallax">
                <div class="boxed-text-xl top-25">
                    <h4 class="text-center mt-4 mb-2">نصب اپلیکیشن در ios</h4>
                    <p class="text-justify mx-3 mb-0">
                        ابتدا وب اپلیکیشن وظایف را در مرورگر سافاری
                        <b>(Safari)</b>
                        خود اجرا کرده سپس آیکون مربوط به اشتراک‌گذاری یا
                        Share
                        موجود در رابط مرورگر سافاری را انتخاب کنید.
                        این آیکون با یک مستطیل و فلشی در درون آن <span class="mx-1"><img src="/assets/images/shair-ios.png" alt="shair-ios" /></span> قابل مشاهده است.
                    </p>
                    <p class="text-justify mx-3 mb-0">
                        در بخش زیرین پنجره باز شده گزینه
                        <b>Add to Home Screen</b>
                        را انتخاب کنید.
                    </p>
                    <p>لینک اپلیکیشن: <a href="https://mtask.dssnovinit.com">https://mtask.dssnovinit.com</a></p>
                    <a href="#" class="pwa-dismiss close-menu btn btn-danger btn-m rounded-s shadow-xl text-uppercase font-900">بستن</a>
                </div>
            </div>
        </div>
        <div id="intro" class="menu menu-box-right bg-gray" data-menu-width="100%" data-menu-effect="menu-over">
            <div class="position-relative">
                <button @click="pauseAllVid()" class="close-menu"><i class="fa fa-times text-white font-26"></i></button>
                <div class="card" data-card-height="90">
                    <div class="card-top">
                        <div class="page-title page-title-small">
                            <h2 class="text-center">معرفی موبایل اپلیکیشن تسکینو</h2>
                        </div>
                    </div>
                    <div class="card-overlay bg-highlight opacity-95"></div>
                    <div class="card-overlay dark-mode-tint"></div>

                    <div class="card-bg bg-20"></div>
                </div>
                <div class="card card-style">
                    <div class="content mt-0 pb-2">
                        <div class="list-group list-custom-small list-icon-0 mt-3 border-b">
                            <div data-toggle="collapse" href="#collapse-0" class="collapsed list-group-div" aria-expanded="true">
                                <i class="fa font-14 fa-info-circle color-magenta1-light"></i>
                                <span class="font-14">معرفی موبایل اپلیکیشن تسکینو <span class="badge bg-red2-light mt-0 px-2 py-2 mr-2 position-static">مهم</span></span>
                                <i class="fa fa-angle-down line-height-xl"></i>
                            </div>
                        </div>
                        <div class="collapse border-b pb-3 show" id="collapse-0" style="">
                            <div class="d-flex justify-content-center">
                                <video class="responsive-video" controls id="video1" preload="none" poster="/assets/images/taskAppHelpVideoPoster.jpg">
                                    <source src="https://dssnovinit.com/Content/Upload/Video/tskMobileAppHelp/Taskino-mobile-app-intro.mp4" type="video/mp4">
                                </video>
                            </div>
                            <a href="https://dssnovinit.com/Content/Upload/Video/tskMobileAppHelp/Taskino-mobile-app-intro.mp4" download target="_blank" class="btn btn-m btn-full bg-highlight rounded-m font-900 mt-3 mx-3">دانلود</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
    export default {
        data() {
            return {
                info: null
            }
        },
        methods: {
            MobileAppUpdates() {
                this.$http.get("Account/GetMobileAppUpdate?appVersionCode=" + this.appVersionCode)
                    .then(data => {
                        let lastUpdate = data.data;
                        if (lastUpdate.downloadUrl != undefined && lastUpdate.downloadUrl != null && lastUpdate.downloadUrl != "") {
                            document.getElementById("linkApp").setAttribute("href", lastUpdate.downloadUrl)
                        }
                    });
            },
            pauseAllVid() {
                document.querySelectorAll('video').forEach(vid => vid.pause());
            },
        },
        mounted() {
            this.MobileAppUpdates();
            document.querySelectorAll(".menu-box-right").forEach(a => a.style.display = "block");
        },

    }
</script>